import { PageId } from "../Core/Content/Types";
export const pageRegistry: {
  id: PageId;
  title: string;
  publicPath: string;
  editorPath: string;
}[] = [
  {
    id: "menu",
    title: "Menu & seasonal items",
    publicPath: "/menu",
    editorPath: "/dashboard/pages/menu",
  },
  {
    id: "home",
    title: "Home",
    publicPath: "/",
    editorPath: "/dashboard/pages/home",
  },
  {
    id: "about",
    title: "About",
    publicPath: "/about",
    editorPath: "/dashboard/pages/about",
  },
  {
    id: "navigation",
    title: "Navigation",
    publicPath: "/",
    editorPath: "/dashboard/site/navigation",
  },
  {
    id: "footer",
    title: "Contact details & footer",
    publicPath: "/",
    editorPath: "/dashboard/site/footer",
  },
];
